import Header from "../../components/Header/Header";
import { Observer, observer } from "mobx-react";
//import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";
import React, { useCallback, useEffect, useRef, useState } from "react";
import search_svg from "../../assets/images/svg/search.svg";
import closeInput from "../../assets/images/svg/closeInput.svg";
import PopupMenu from "../../components/PopupMenu/PopupMenu";
import RadioGroup from "../../components/Reports/RadioGroup";
import {
  REPORTS_PAGE,
  transectionsTimePeriodRadioBtnsData,
  RECENT_TRANSACTIONS,
  UPCOMING_TRANSACTIONS,
  oneDayDif,
  reportTypeValues,
  exportDataMenu,
} from "../../utils/constants";
import GoldenDropDown from "../../components/Reports/GoldenDropDown";
import ApplyFilter from "../../components/Reports/ApplyFilter";
import Table from "../../components/Table2";
import Tabs from "../../components/Tabs";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import {
  commaSeperated,
  convertDateToObj,
  displayUnit,
  downloadPDFFile,
  exportExcel,
  getAcquisitionValue,
  getAsOfDate,
  getCurrentDate,
  getDateString,
  getDecodedToken,
  getDefaultDateType,
  getDisplayDate,
  getExcelDate,
  getExcelDate2,
  getExcelNumData2,
  getExcelPdfName,
  getPrintDate,
  getSecond,
  getTextColor,
  lakhAmt,
  logEvents,
  padNumber,
  // printDocument,
  showDataWithRupeeDashOrZero,
  trackEventWithScreen,
} from "../../utils/functions";
import EmptyDerivatives from "../../components/EmptyDerivaties/EmptyDerivaties";
import emptyIcon from "../../assets/images/svg/empty.svg";
import ModalFamilyWithCheckboxes from "../../components/ModalFamily/ModalFamilyWithCheckboxes";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import DatePicker2 from "../../components/Reports/DatePicker2";
import { useNavigate } from "react-router";
//import PdfTable from "../../components/PdfTable/PdfTable";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ReportsStore from "../../store/ReportsStore";
import OverflowingText from "../../components/OverflowingText/OverflowingText";
import { setCookie, getCookie } from "../../utils/cookie";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import ExportReportList from "../../components/AccessibleDropdown/ExportReportList";
import AcquisitionDateTypeDropdown from "../../components/Reports/PortfolioReport/AcquisitionDateTypeDropdown";
import AccountsDropDown from "../../components/Reports/UnrealisedGLReport/AccountsDropDown";
import AssetClassesCheckBox from "../../components/Reports/AssetClassesCheckBox";
import NoDataText from "../../components/NoDataText/NoDataText";

const dateCellRenderer = (data) => {
  const dateValue = getDisplayDate(data);

  return (
    <p
      style={{ fontFamily: "Encode Sans", whiteSpace: "nowrap" }}
      className="date_cell transacDate"
    >
      {" "}
      {dateValue ? <span>{dateValue}</span> : <NoDataText />}
    </p>
  );
};

const dateCellRendererForExportExcelPDF = (data) => {
  return getExcelDate(data) || "-";
};
const qtyCellRenderer = (data) => {
  return <p className="qty_cell font-roboto">{commaSeperated(data) || "-"}</p>;
};

const navCellRenderer = (data) => {
  return (
    <p className="qty_cell font-roboto">
      {data ? <span>{showDataWithRupeeDashOrZero(data)}</span> : <NoDataText />}
    </p>
  );
};

const amtCellRendererForRecent = (data, row, key) => {
  return (
    <p className="qty_cell font-roboto">
      {row?.expectedAmount?.actual_value ? (
        <p>
          {showDataWithRupeeDashOrZero(row?.expectedAmount?.value)}
          <span className="unitFont">{` ${displayUnit(
            row?.expectedAmount?.value_type,
          )}`}</span>
        </p>
      ) : (
        "-"
      )}
    </p>
  );
};
const amtCellRendererForRecent2 = (data, row, key) => {
  return (
    <p className="qty_cell font-roboto">
      {row?.amount?.actual_value ? (
        <p>
          {showDataWithRupeeDashOrZero(row?.amount?.value)}
          <span className="unitFont">{` ${displayUnit(
            row.amount.value_type,
          )}`}</span>
        </p>
      ) : (
        "-"
      )}
    </p>
  );
};
const CountCellRendererForRecent = (data) => {
  return (
    <p className="qty_cell">{data ? <span>{data}</span> : <NoDataText />} </p>
  );
};
const frequencyCellRendererForRecent = (data) => {
  return (
    <p className="qty_cell">{data ? <span>{data}</span> : <NoDataText />}</p>
  );
};

const actionCellRenderer = (data) => {
  return (
    <p className="action_cell" style={{ fontSize: 12, textAlign: "right" }}>
      {data || "-"}
    </p>
  );
};
const ttypeCellRenderer = (data) => {
  return (
    <p
      className={`ttype_cell ${getTextColor(data ? data : "")}`}
      style={{ paddingRight: 0 }}
    >
      {data?.toUpperCase() || "-"}
    </p>
  );
};

const asscCellRenderer = (data) => {
  return <p className="assc_cell">{data || "-"}</p>;
};

const columTransactionForPDF = [
  {
    label: "Instrument Name",
    key: "security_name",
    width: "330px",
    sortable: true,
  },
  {
    label: "Price",
    key: "rate",
    sortable: true,
    cellRenderer: navCellRenderer,
    cellRendererPdf: (data, row, key) => getExcelNumData2(data, false, 2),
  },
  {
    label: "Qty",
    key: "quantity",
    sortable: true,
    cellRenderer: qtyCellRenderer,
    // cellRendererPdf: (data, row, key) => getExcelNumData2(data, false, 0),
  },
  {
    label: "Amount",
    key: "amount",
    classn: "nav_table_head",
    sortable: true,
    cellRendererPdf: (data, row, key) =>
      getExcelNumData2(row?.amount?.actual_value, true, 2),
  },
  {
    label: "Transaction Type",
    key: "type",
    sortable: true,
    cellRenderer: ttypeCellRenderer,
  },
  {
    label: "Asset Class",
    key: "asset_class",
    cellRenderer: asscCellRenderer,
  },
  {
    label: "Sub Asset Class",
    key: "sub_asset_class",
    cellRenderer: asscCellRenderer,
  },
  {
    label: "Date",
    key: "transaction_date",
    sortable: true,
    cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
    cellRendererPdf: dateCellRendererForExportExcelPDF,
  },
  {
    label: "Expiry Date",
    key: "expiry_date",
    sortable: true,
    cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
    cellRendererPdf: dateCellRendererForExportExcelPDF,
  },
  {
    label: "Client Name",
    key: "client_name",
    sortable: true,
    cellRenderer: asscCellRenderer,
  },
  {
    label: "Account Name",
    key: "account_name",
    sortable: true,
    cellRenderer: asscCellRenderer,
  },
];

const TransactionsReport = observer(() => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchSuggetions, setSearchSuggetions] = useState([]);
  const [selectedSuggetion, setSelectedSuggetion] = useState(null);
  const [searchSuggetionOpen, setSearchSuggetionOpen] = useState("");
  //const [niftyMenu, setNiftyMenu] = useState(false);
  const [timePeriod, setTimePeriod] = useState(
    UserStore.transectionReportFilter.timePeriod,
  );
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(
    UserStore.transectionReportFilter.selectedMember,
  );
  const [allMembersMenuOpen, setAllMembersMenuOpen] = useState(false);
  const [selectedAssetClass, setSelectedAssetClass] = useState(
    UserStore.transectionReportFilter.selectedAssetClass,
  );
  // const [allAssetClassMenuOpen, setAllAssetClassMenuOpen] = useState(false);
  const [selectedAccount1, setSelectedAccount1] = useState(
    UserStore.transectionReportFilter.selectedAccount,
  );
  // const [allAccountsMenuOpen1, setAllAccountsMenuOpen1] = useState(false);
  const [selectedTransecitonTypes, setSelectedTransecitonTypes] = useState(
    UserStore.transectionReportFilter.transectionType,
  );
  const [isSort, setSort] = useState("asc");
  const [filteredColumn, setFilteredColumn] = useState("transaction_date");
  const [isAscendingForHeader, setIsAscendingForHeader] = useState(false);
  const [filteredColumnForUpcoming, setFilteredColumnForUpcoming] =
    useState("lastpaymentdate");
  const [isAscendingForHeaderForUpcoming, setIsAscendingForHeaderForUpcoming] =
    useState(true);
  const [
    selectedUpcomingTransecitonTypes,
    setSelectedUpcomingTransecitonTypes,
  ] = useState(UserStore.transectionReportFilter.upcomingtransectionType);
  const [fromDate, setFromDate] = useState(
    convertDateToObj(getCookie("asOfDate")),
  );
  const [toDate, setToDate] = useState(convertDateToObj(getCookie("asOfDate")));
  const [initialFromDate, setInitialFromDate] = useState(null);
  const [initialToDate, setInitialToDate] = useState(null);
  const [vertualRows, setVertualRows] = useState([]);

  const [upcomingtransactionsData, setUpcomingTransactionsData] = useState(
    ReportsStore.upcomingtransectionTableData,
  );
  const [resetedFromDate, setResetedFromDate] = useState(null);
  const [resetedToDate, setResetedToDate] = useState(null);
  const [isTab, setIsTab] = useState(false);
  const [loading, setLoading] = useState(true);

  const [searchedData, setSearchedData] = useState([]);

  const [selectedAcquisitionDate, setSelectedAcquisitionDate] = useState(
    UserStore.transectionReportFilter.selectedAcquisitionDate,
  );

  // const [acquisitionDateMenuOpen, setAcquisitionDateMenuOpen] = useState(false);

  const [acquisitionOptions, setAcquisitionOptions] = useState([]);
  //const [focusedIndex, setFocusedIndex] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);

  const selectedTabs = ReportsStore.selectedTabForTransaction;
  const loadingScreen = AuthStore.isLoadingFullScreen;
  const userHydrated = UserStore.isHydrated;
  const reportFilter = UserStore.transectionReportFilter;
  const upcomingData = ReportsStore.upcomingtransectionTableData;
  const transactionTableData = ReportsStore.transectionTableData;

  const exportRef = useRef(null);
  const ref = useRef(null);
  //const itemRefs = useRef([]);
  const exportItemRefs = useRef([]);

  const onClickOutside = useCallback((menu) => {
    switch (menu) {
      case "suggetion":
        setSearchSuggetionOpen(false);
        break;
      // case "export":
      //   setNiftyMenu(false);
      //   break;
      default:
        break;
    }
  }, []);

  // const handleChangeOnAcquisitionDate = (value) => {
  //   setSelectedAcquisitionDate(value);
  //   setAcquisitionDateMenuOpen(false);
  // };

  // Function for Keyboard accessibility in date type dropdown content
  // const handleKeyDownOnAcquisitionDate = (e, index) => {
  //   switch (e.key) {
  //     case "ArrowDown":
  //       e.preventDefault();
  //       setFocusedIndex((prev) => (prev + 1) % acquisitionOptions.length);
  //       break;

  //     case "ArrowUp":
  //       e.preventDefault();
  //       setFocusedIndex((prev) =>
  //         prev === 0 ? acquisitionOptions.length - 1 : prev - 1,
  //       );
  //       break;

  //     case "Tab":
  //       setAcquisitionDateMenuOpen(false);
  //       break;

  //     case "Enter":
  //     case " ":
  //       e.preventDefault();
  //       handleChangeOnAcquisitionDate(acquisitionOptions[index]);
  //       break;
  //   }
  // };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside("suggetion");
      }
      if (exportRef.current && !exportRef.current.contains(event.target)) {
        onClickOutside && onClickOutside("export");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      setTimeout(() => {
        document.removeEventListener("click", handleClickOutside, true);
      }, 10);
    };
  }, [onClickOutside]);

  const handleTimePeriodChange = (selectedTimePeriod) => {
    setTimePeriod(selectedTimePeriod);
  };

  const instrumentNameCell = (data, _, __, index) => {
    return (
      <OverflowingText
        text={data || "-"}
        textClassName={"transaction_report_instrument_name"}
        width={220}
        position="right"
      />
    );
  };

  const columTransaction = [
    {
      label: "Instrument Name",
      key: "security_name",
      width: "200px",
      sortable: true,
      cellRenderer: instrumentNameCell,
    },
    {
      label: "Price",
      key: "rate",
      width: "145px",
      sortable: true,
      cellRenderer: navCellRenderer,
    },
    {
      label: "Qty",
      key: "quantity",
      width: "145px",
      sortable: true,
      cellRenderer: qtyCellRenderer,
    },
    {
      label: "Amount",
      key: "amount",
      classn: "nav_table_head",
      width: "141px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent2,
      cellRendererPdf: (data, row, key) => `${lakhAmt(data?.actual_value)}`,
    },
    {
      label: "Transaction Type",
      key: "type",
      width: "175px",
      sortable: true,
      cellRenderer: ttypeCellRenderer,
    },
    {
      label: "Asset Class",
      key: "asset_class",
      cellRenderer: asscCellRenderer,
      width: "175px",
    },
    {
      label: "Date",
      key: "transaction_date",
      width: "149px",
      sortable: true,
      cellRenderer: dateCellRenderer,
      cellRendererPdf: (data) => getExcelDate(data),
    },
    {
      label: "Expiry Date",
      key: "expiry_date",
      width: "149px",
      sortable: true,
      cellRenderer: dateCellRenderer,
      cellRendererPdf: (data) => getExcelDate(data),
    },
  ];

  const corporateActionsColumns = [
    {
      label: "Instrument Name",
      key: "security_name",
      width: "370px",
      sortable: true,
      cellRenderer: instrumentNameCell,
    },
    {
      label: "Date",
      key: "lastpaymentdate",
      width: "170px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRendererPdf: dateCellRendererForExportExcelPDF,
      cellRenderer: dateCellRenderer,
    },
    {
      label: "Amount",
      key: "amount",
      width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) =>
        getExcelNumData2(row?.expectedAmount?.actual_value),
    },
    {
      label: "Drawdown Count",
      key: "drawcount",
      width: "186px",
      sortable: true,
      cellRenderer: CountCellRendererForRecent,
      cellRendererPdf: (data, row, key) => (data ? data : "-"),
    },
    {
      label: "Frequency",
      key: "frequency",
      sortable: true,
      width: "156px",
      cellRenderer: frequencyCellRendererForRecent,
      cellRendererPdf: (data, row, key) => (data ? data : "-"),
    },
    {
      label: "Transaction Type",
      key: "type",
      sortable: true,
      width: "186px",
      cellRenderer: actionCellRenderer,
    },
  ];

  useEffect(() => {
    if (
      document.documentElement.clientWidth < 1194 &&
      document.documentElement.clientWidth > 768
    ) {
      setIsTab(true);
    }
    // eslint-disable-next-line
  }, [document.documentElement.clientWidth]);

  useEffect(() => {
    if (selectedSuggetion) {
      const filtered = ReportsStore.transectionTableData?.filter(
        (eachTransaction) => {
          return eachTransaction?.security_name === selectedSuggetion?.title;
        },
      );
      setSearchedData(filtered);
      ReportsStore.updateTransactionReportData(filtered);
    } else {
      ReportsStore.updateTransactionReportData(
        ReportsStore.rememberedTransectionTableData,
      );
      setSearchedData([]);
    }
  }, [selectedSuggetion]);

  useEffect(() => {
    if (UserStore.isHydrated)
      setVertualRows(ReportsStore.transectionTableData?.slice(0, 100));
  }, [
    transactionTableData,
    UserStore.isHydrated,
    //ReportsStore.transectionTableData
  ]);

  useEffect(() => {
    setUpcomingTransactionsData(ReportsStore.upcomingtransectionTableData);
  }, [
    upcomingData,
    //ReportsStore.upcomingtransectionTableData
  ]);

  useEffect(() => {
    if (datePickerModalOpen) {
      setInitialFromDate(fromDate);
      setInitialToDate(toDate);
    }
    // eslint-disable-next-line
  }, [datePickerModalOpen]);

  useEffect(() => {
    setSelectedTransecitonTypes(
      UserStore.transectionReportFilter.transectionType,
    );
    setSelectedUpcomingTransecitonTypes(
      UserStore.transectionReportFilter.upcomingtransectionType,
    );
    setSelectedAssetClass(UserStore.transectionReportFilter.selectedAssetClass);
    setSelectedMember(UserStore.transectionReportFilter.selectedMember);
    setSelectedAccount1(UserStore.transectionReportFilter.selectedAccount);
    setTimePeriod(UserStore.transectionReportFilter.timePeriod);
    setSelectedAcquisitionDate(
      UserStore.transectionReportFilter.selectedAcquisitionDate,
    );
  }, [
    reportFilter,
    //UserStore.transectionReportFilter
  ]);

  useEffect(() => {
    if (UserStore.isHydrated) {
      let as_of_date = getAsOfDate(UserStore.asOfDate);
      if (!getAsOfDate(UserStore.asOfDate)) as_of_date = getCookie("asOfDate");
      const dateObjofAsOfDate = new Date(as_of_date);
      let newTodate;
      let formattedTodate;
      if (!resetedFromDate && !resetedToDate) {
        newTodate = new Date(UserStore.forReportsInceptionDate);
        formattedTodate =
          newTodate?.getFullYear() +
          "-" +
          padNumber(newTodate?.getMonth() + 1) +
          "-" +
          padNumber(newTodate?.getDate());
        setResetedFromDate(convertDateToObj(formattedTodate));
        setResetedToDate(convertDateToObj(as_of_date));
      }
      let formattedFromdate;
      let newFromdate;

      formattedFromdate =
        newFromdate?.getFullYear() +
        "-" +
        padNumber(newFromdate?.getMonth() + 1) +
        "-" +
        padNumber(newFromdate?.getDate());

      const currentQuarter = Math.floor(dateObjofAsOfDate.getMonth() / 3);
      const quarterStartDate = new Date(
        dateObjofAsOfDate.getFullYear(),
        currentQuarter * 3,
      );

      switch (timePeriod) {
        case "current_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth(),
            1,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_month":
          newFromdate = new Date(
            dateObjofAsOfDate.getFullYear(),
            dateObjofAsOfDate.getMonth() - 1,
            1,
          );
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          let dummyDateObj = new Date(as_of_date);
          let dummyTime = dummyDateObj?.setDate(1);
          newTodate = new Date(dummyTime - oneDayDif);

          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_fy":
          newFromdate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 1
                : dateObjofAsOfDate.getFullYear()
            }`,
            3,
          );

          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_fy":
          newFromdate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 2
                : dateObjofAsOfDate.getFullYear() - 1
            }`,
            3,
            1,
          );

          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          newTodate = new Date(
            `${
              dateObjofAsOfDate.getMonth() - 3 < 0
                ? dateObjofAsOfDate.getFullYear() - 1
                : dateObjofAsOfDate.getFullYear()
            }`,
            2,
            31,
          );
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "current_quarter":
          newFromdate = quarterStartDate;
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(as_of_date));
          break;
        case "previous_quarter":
          const currentQuarterStartDate = quarterStartDate;
          const currentQuarterEndDate = new Date(
            quarterStartDate.getFullYear(),
            quarterStartDate.getMonth() + 2,
            0,
          );
          const previousQuarterStartDate = new Date(
            currentQuarterStartDate.getFullYear(),
            currentQuarterStartDate.getMonth() - 3,
          );
          const previousQuarterEndDate = new Date(
            currentQuarterEndDate.getFullYear(),
            currentQuarterEndDate.getMonth() - 1,
            0,
          );
          newFromdate = previousQuarterStartDate;
          formattedFromdate =
            newFromdate?.getFullYear() +
            "-" +
            padNumber(newFromdate?.getMonth() + 1) +
            "-" +
            padNumber(newFromdate?.getDate());
          newTodate = previousQuarterEndDate;
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());
          setFromDate(convertDateToObj(formattedFromdate));
          setToDate(convertDateToObj(formattedTodate));
          break;
        case "itd":
          newTodate = new Date(UserStore.forReportsInceptionDate);
          formattedTodate =
            newTodate?.getFullYear() +
            "-" +
            padNumber(newTodate?.getMonth() + 1) +
            "-" +
            padNumber(newTodate?.getDate());

          setFromDate(convertDateToObj(formattedTodate));
          setToDate(convertDateToObj(as_of_date));
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line
  }, [timePeriod, UserStore.isHydrated]);

  useEffect(() => {
    if (getAsOfDate(UserStore.asOfDate)) {
      setCookie("asOfDate", getAsOfDate(UserStore.asOfDate));
    }
    setTimePeriod("current_month");

    return () => {
      setTimeout(() => {
        ReportsStore.updateAllAccountToDefault();
        ReportsStore.updateRememberedTransactionReportData([]);
        ReportsStore.updateTransactionReportData([]);
      }, 10);
    };
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "ArrowDown" && searchSuggetionOpen) {
      e.preventDefault();
      const suggetionElArr = document.getElementById(
        "transaction_suggetion_box_for_search",
      ).children;
      if (document.activeElement === document.getElementById("search-box")) {
        e.preventDefault();
        suggetionElArr[0].focus();
      }
    }
    if (e.key === "ArrowUp" && searchSuggetionOpen) {
      e.preventDefault();
      const suggetionElArr = document.getElementById(
        "transaction_suggetion_box_for_search",
      ).children;
      if (document.activeElement === document.getElementById("search-box")) {
        e.preventDefault();
        suggetionElArr[suggetionElArr?.length - 1].focus();
      }
    }
  };

  const handleKeydownForSuggetion = (e) => {
    if (e.key === "Enter") {
      e.target.click();
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const nextEl = document.activeElement.nextElementSibling;
      if (!nextEl) {
        const suggetionElArr = document.getElementById(
          "transaction_suggetion_box_for_search",
        ).children;
        suggetionElArr[0].focus();
        return;
      }
      nextEl.focus();
      return;
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const prevEl = document.activeElement.previousElementSibling;
      if (!prevEl) {
        const suggetionElArr = document.getElementById(
          "transaction_suggetion_box_for_search",
        ).children;
        suggetionElArr[suggetionElArr?.length - 1].focus();
        return;
      }
      prevEl.focus();
      return;
    }
  };

  // const AllAssetClassMenuContent = () => {
  //   const handleAssetClassChange = (changedAssetClass) => {
  //     if (changedAssetClass === "All") {
  //       if (
  //         selectedAssetClass === "All" ||
  //         ReportsStore.allAssetClassesData
  //           ?.map((assetClass) => selectedAssetClass?.includes(assetClass.id))
  //           ?.every(Boolean)
  //       ) {
  //         setSelectedAssetClass([]);
  //       } else {
  //         setSelectedAssetClass(
  //           ReportsStore.allAssetClassesData.map((assetClass) => {
  //             return assetClass.id;
  //           }),
  //         );
  //       }
  //     } else {
  //       if (selectedAssetClass === "All") {
  //         setSelectedAssetClass(
  //           ReportsStore.allAssetClassesData
  //             .map((assetClass) => {
  //               return assetClass.id;
  //             })
  //             .filter((assetClassId) => assetClassId !== changedAssetClass),
  //         );
  //       } else {
  //         if (selectedAssetClass.includes(changedAssetClass)) {
  //           setSelectedAssetClass((prevState) => {
  //             return prevState.filter(
  //               (eachAssetClass) => eachAssetClass !== changedAssetClass,
  //             );
  //           });
  //         } else {
  //           setSelectedAssetClass([...selectedAssetClass, changedAssetClass]);
  //         }
  //       }
  //     }
  //   };
  //   return (
  //     <ul className="portfolio_report_accounts_container">
  //       <li
  //         className="account_listitem"
  //         style={{ cursor: "pointer" }}
  //         onClick={() => handleAssetClassChange("All")}
  //       >
  //         <div className="each_checkbox_wrapper">
  //           <input
  //             checked={
  //               selectedAssetClass === "All" ||
  //               ReportsStore.allAssetClassesData
  //                 ?.map((assetClass) =>
  //                   selectedAssetClass?.includes(assetClass.id),
  //                 )
  //                 ?.every(Boolean)
  //             }
  //             onChange={() => handleAssetClassChange("All")}
  //             type="checkbox"
  //             className="checkbox"
  //           />
  //           <label className="checkbox_label cursor">All Asset Classes</label>
  //         </div>
  //       </li>
  //       {ReportsStore.allAssetClassesData?.map((assetClass, index) => (
  //         <li
  //           className="account_listitem"
  //           style={{ cursor: "pointer" }}
  //           onClick={() => handleAssetClassChange(assetClass.id)}
  //         >
  //           <div className="each_checkbox_wrapper">
  //             <input
  //               checked={
  //                 selectedAssetClass === "All" ||
  //                 selectedAssetClass.includes(assetClass.id)
  //                   ? true
  //                   : false
  //               }
  //               onChange={() => handleAssetClassChange(assetClass.id)}
  //               type="checkbox"
  //               className="checkbox"
  //             />
  //             <label
  //               className="checkbox_label cursor"
  //               for={assetClass.id}
  //               style={{ display: "contents" }}
  //             >
  //               <OverflowingText
  //                 text={
  //                   assetClass?.name
  //                     ? `${assetClass?.name
  //                         .charAt(0)
  //                         .toUpperCase()}${assetClass?.name
  //                         .slice(1)
  //                         .toLowerCase()}`
  //                     : assetClass?.name
  //                 }
  //                 width={140}
  //                 textClassName="radio_btn_label cursor_imp"
  //                 tooltipOnHover={true}
  //                 position="left"
  //                 tooltipClassName={
  //                   index === 0
  //                     ? "asset_class_tooltip_styles_bottom"
  //                     : "asset_class_tooltip_styles"
  //                 }
  //               />
  //             </label>
  //           </div>
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // };

  const getAccountsList = () => {
    if (
      UserStore?.selectedClientId !== "0" &&
      getCookie("isPrimary") === "false"
    ) {
      return ReportsStore?.allAccountsData?.[
        UserStore?.selectedClientId
      ]?.flat();
    } else {
      if (selectedMember === "All") {
        if (ReportsStore?.allAccountsData) {
          return Object?.values(ReportsStore?.allAccountsData)?.flat();
        }
      } else {
        return selectedMember
          ?.map(
            (eachMember) =>
              ReportsStore?.allAccountsData?.[eachMember?.user_id],
          )
          ?.flat();
      }
    }
  };

  const AllMembersMenuContent = () => {
    return (
      <ul className="portfolio_report_container">
        <ModalFamilyWithCheckboxes
          setSelectedMemberForReports={(id) => {
            setSelectedMember(id);
          }}
          isSort={isSort}
          setSort={setSort}
          selectedMemberForReports={selectedMember}
          showResetAndSubmit={false}
          searchBarWidth="351px"
        />
      </ul>
    );
  };

  const recentTransactionId = "recentTransactionId";

  const getCurrentTime = () => {
    const newTime = new Date();
    return `${newTime.getHours()}:${newTime.getMinutes()}:${getSecond(
      newTime.getSeconds(),
    )}`;
  };

  const getDateType = ({ data }) => {
    return data === "Transfer-In Date" ? "TransferInDate" : "InceptionDate";
  };

  // const ExtractDataContent = () => {
  //   const fileName = `${getExcelPdfName(
  //     "Transactions Report -",
  //     UserStore?.transectionReportFilter?.selectedMember,
  //     UserStore?.transectionReportFilter?.selectedAccount,
  //     UserStore.getData,
  //     UserStore.userData.full_name,
  //   )} - ${getCurrentDate()} ${getCurrentTime()} - ${getDateType({
  //     data:
  //       UserStore.transectionReportFilter.selectedAcquisitionDate ||
  //       getDefaultDateType({
  //         data: UserStore.usersData,
  //       }),
  //   })}`;

  //   const exportExcelClick = () => {
  //     exportExcel({
  //       dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
  //       sheetname: "Transactions",
  //       isFamilyOnly: true,
  //       // customNameWithTime: getExcelPdfName(
  //       //   "",
  //       //   UserStore?.transectionReportFilter?.selectedMember,
  //       //   UserStore?.transectionReportFilter?.selectedAccount,
  //       //   UserStore.getData,
  //       //   UserStore.userData.full_name
  //       // ),
  //       columns:
  //         ReportsStore.selectedTabForTransaction === "recent_transaction"
  //           ? columTransactionForPDF
  //           : corporateActionsColumns,
  //       data:
  //         (ReportsStore.selectedTabForTransaction === "recent_transaction"
  //           ? getTransactionsDataForPDF()
  //           : getUpcomingTransactionsData()) || [],
  //       reportDetails: {
  //         relatioshipManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "RM",
  //         )?.name,
  //         serviceManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "CXO",
  //         )?.name,
  //         date: getPrintDate(getAsOfDate(UserStore.asOfDate)),
  //         clientName:
  //           //UserStore.getData === "fam"
  //           //?
  //           UserStore.userData?.family_name,
  //         //: UserStore.userData?.full_name,
  //       },
  //       excelName: fileName,
  //     });
  //   };

  //   const exportPdf = async () => {
  //     // printDocument(recentTransactionId, {
  //     //   width: 850,
  //     //   height: 850,
  //     //   customFileName: fileName,
  //     // });
  //     if (isDownloading) return; // guard against double-click while already running
  //     setIsDownloading(true);
  //     try {
  //       await downloadPDFFile({
  //         customFileName: fileName,
  //         headerName: "Transactions",
  //         fileId: recentTransactionId,
  //         isFamilyOnly: true,
  //         dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
  //         familyOrClientName: UserStore.userData?.family_name,
  //         columns:
  //           ReportsStore.selectedTabForTransaction === "recent_transaction"
  //             ? columTransactionForPDF
  //             : corporateActionsColumns,
  //         data:
  //           (ReportsStore.selectedTabForTransaction === "recent_transaction"
  //             ? getTransactionsDataForPDF()
  //             : getUpcomingTransactionsData()) || [],
  //       });
  //     } finally {
  //       setIsDownloading(false);
  //       setNiftyMenu(false);
  //     }
  //   };

  //   return (
  //     <>
  //       <div className="extract_data_container downloadPdf">
  //         <p className="export_data_text">Export Data</p>
  //         <ul className="listitem_container">
  //           <li
  //             onClick={() => {
  //               exportExcelClick();
  //               setNiftyMenu(false);
  //             }}
  //           >
  //             <div className="listitem_icon excel"></div> Export to Excel
  //           </li>
  //           <li
  //             onClick={() => {
  //               exportPdf();
  //               //setNiftyMenu(false);
  //             }}
  //           >
  //             <div className="listitem_icon pdf"></div> Export to PDF
  //           </li>
  //         </ul>
  //         {isDownloading && (
  //           <div className="popup_downloader">
  //             <img src={loaderGIF} alt="img" />
  //           </div>
  //         )}
  //       </div>
  //       <div></div>
  //     </>
  //   );
  // };

  const setReportTypeData = ({ data, usersData }) => {
    let reportType = null;
    let reportTypeArr = [];

    if (data !== "(Inception)") {
      reportType = "Transfer-In Date";
    } else {
      reportType = "Inception Date";
    }

    if (usersData !== "(Inception)") {
      reportTypeArr = ["Transfer-In Date", "Inception Date"];
    } else {
      reportTypeArr = ["Inception Date", "Transfer-In Date"];
    }

    setSelectedAcquisitionDate(reportType);
    setAcquisitionOptions(reportTypeArr);
  };

  useEffect(() => {
    if (UserStore.isHydrated) {
      const fetchData = async () => {
        const userId = getCookie("userid");

        const reportTypeFilter =
          reportTypeValues[
            UserStore.transectionReportFilter.selectedAcquisitionDate
          ];
        let processReportType = null;

        if (UserStore.usersData) {
          processReportType = UserStore.usersData;
          setReportTypeData({
            data: reportTypeFilter || processReportType,
            usersData: processReportType,
          });
        }

        const onProfileDataSuccess = ({ ...rest }) => {
          if (!processReportType) {
            processReportType = rest.processReportTypeText;
            setReportTypeData({
              data: reportTypeFilter || processReportType,
              usersData: processReportType,
            });
          }
        };
        await ReportsStore?.getprofile({
          userId,
          onSuccess: onProfileDataSuccess,
        });
        ReportsStore.updateTableDataLoader(true);
        window.scrollTo(0, 0);
        document.addEventListener("scroll", () => {
          if (document.documentElement.scrollTop === 0) {
            setVertualRows(ReportsStore.transectionTableData?.slice(0, 100));
          }
          if (
            document.documentElement.scrollHeight -
              document.documentElement.scrollTop +
              document.documentElement.clientHeight <
              2000 &&
            ReportsStore.transectionTableData?.length
          ) {
            if (vertualRows) {
              setVertualRows((prev) => {
                if (prev) {
                  return [
                    ...prev,
                    ...ReportsStore.transectionTableData.slice(
                      prev?.length,
                      prev?.length + 100,
                    ),
                  ];
                }
              });
            }
          }
        });
        ReportsStore.populateReportsData();
        ReportsStore.updateTransectionReportTab("recent_transaction");
      };
      fetchData();

      return () => {
        setTimeout(() => {
          ReportsStore.updateTableDataLoader(true);
          ReportsStore.updateTransectionFilter(
            {
              timePeriod: "current_month",
              transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
              upcomingtransectionType: [
                "SIP",
                "STP",
                "SWP",
                "DRAWDOWN",
                "MATURITY",
              ],
              selectedMember:
                (getDecodedToken()?.user_type === "employee" ||
                  getDecodedToken()?.user_type === "customer") &&
                UserStore.selectedClientId === "0"
                  ? "All"
                  : selectedMember !== "All"
                    ? selectedMember
                    : UserStore.transectionReportFilter.selectedMember,
              selectedAssetClass: "All",
              selectedAccount: "All",
              selectedAcquisitionDate: getDefaultDateType({
                data: UserStore.usersData,
              }),
            },
            "check9",
          );
        }, 10);
      };
    }
    // eslint-disable-next-line
  }, [UserStore.isHydrated]);

  useEffect(() => {
    if (AuthStore.isLoadingFullScreen) {
      setLoading(false);
    }
  }, [
    loadingScreen,
    userHydrated,
    //AuthStore.isLoadingFullScreen, UserStore.isHydrated
  ]);

  useEffect(() => {
    if (
      ReportsStore.allAssetClassesAPIcallstate === "success" &&
      ReportsStore.allAccountsAPIcallstate === "success" &&
      ReportsStore.allMembersAPIcallstate === "success" &&
      UserStore.isHydrated
    ) {
      if (fromDate && toDate) {
        ReportsStore.updateTableDataLoader(true);
        ReportsStore.getDataForTransectionReport(
          `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
          `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
          false,
          {
            IsAcquisition: getAcquisitionValue({
              data: selectedAcquisitionDate,
            }),
          },
        );
      }
    }
    // eslint-disable-next-line
  }, [
    ReportsStore.allAssetClassesAPIcallstate,
    ReportsStore.allAccountsAPIcallstate,
    ReportsStore.allMembersAPIcallstate,
    UserStore.isHydrated,
  ]);

  useEffect(() => {
    if (
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "true") ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore.userData?.isprimary)
    ) {
      if (
        selectedMember === "All" ||
        UserStore.currentFamilyMembers
          ?.map((familyMember) =>
            selectedMember.find(
              (member) => member?.user_id === familyMember?.user_id,
            ),
          )
          ?.every(Boolean)
      ) {
        setSelectedAccount1("All");
      }
    }
  }, [selectedMember]);

  const handleTranTypeChange = (clickedTranType, type) => {
    if (type === "upcoming") {
      if (selectedUpcomingTransecitonTypes.includes(clickedTranType)) {
        setSelectedUpcomingTransecitonTypes((prevState) => {
          if (prevState.length !== 1) {
            return prevState.filter(
              (eachTranType) => eachTranType !== clickedTranType,
            );
          } else {
            return prevState;
          }
        });
      } else {
        setSelectedUpcomingTransecitonTypes([
          ...selectedUpcomingTransecitonTypes,
          clickedTranType,
        ]);
      }
    } else {
      if (selectedTransecitonTypes.includes(clickedTranType)) {
        setSelectedTransecitonTypes((prevState) => {
          if (prevState.length !== 1) {
            return prevState.filter(
              (eachTranType) => eachTranType !== clickedTranType,
            );
          } else {
            return prevState;
          }
        });
      } else {
        setSelectedTransecitonTypes([
          ...selectedTransecitonTypes,
          clickedTranType,
        ]);
      }
    }
  };

  const getHeadingForAssetClass = (selectedAssetClass) => {
    if (
      selectedAssetClass === "All" ||
      ReportsStore.allAssetClassesData
        ?.map((assetClass) => selectedAssetClass?.includes(assetClass.id))
        ?.every(Boolean)
    ) {
      return isTab && false
        ? `${"All Asset Classes".slice(0, 15)}...`
        : "All Asset Classes";
    } else if (selectedAssetClass.length === 0) {
      return "None selected";
    } else {
      const data = ReportsStore.allAssetClassesData
        ?.map((assetClass) =>
          selectedAssetClass?.includes(assetClass?.id) ? assetClass?.name : "",
        )
        .filter((selectedAssetClass) => selectedAssetClass);
      if (data?.length === 1) {
        return data?.[0];
      }
      return data.map((obj) => obj).join(", ");
    }
  };

  const getHeadingForMembers = (selectedMember) => {
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        !UserStore.userData?.isprimary &&
        UserStore?.selectedClientId !== "0") ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false") ||
      ((getDecodedToken()?.user_type === "customer" ||
        getDecodedToken()?.user_type === "employee") &&
        UserStore.currentFamilyMembers?.length === 1)
    ) {
      return UserStore?.userData?.full_name;
    } else {
      if (
        selectedMember === "All" ||
        UserStore.currentFamilyMembers
          ?.map((familyMember) =>
            selectedMember.find(
              (member) => member?.user_id === familyMember?.user_id,
            ),
          )
          ?.every(Boolean)
      ) {
        return "All Members";
      } else if (selectedMember.length === 0) {
        return "None selected";
      } else {
        const data = selectedMember;
        if (data.length === 1) {
          return data[0].full_name;
        }
        return data.map((obj) => obj.full_name).join(", ");
      }
    }
  };

  const onApplyFilter = (fromDate1 = fromDate, toDate1 = toDate) => {
    setFilteredColumnForUpcoming("security_name");
    setIsAscendingForHeaderForUpcoming(false);
    setFilteredColumn("transaction_date");
    setIsAscendingForHeader(false);
    setSearch("");
    setSelectedSuggetion(null);
    if (!selectedMember?.length || !selectedAssetClass?.length) {
      ReportsStore.transectionTableData = [];
      ReportsStore.upcomingtransectionTableData = [];
    } else {
      ReportsStore.updateTableDataLoader(true);
      ReportsStore.updateTransectionFilter(
        {
          timePeriod: timePeriod,
          transectionType: selectedTransecitonTypes,
          upcomingtransectionType: selectedUpcomingTransecitonTypes,
          selectedMember:
            selectedMember?.length === UserStore.currentFamilyMembers?.length
              ? "All"
              : selectedMember !== "All"
                ? selectedMember
                : UserStore.transectionReportFilter.selectedMember,
          selectedAssetClass: selectedAssetClass,
          selectedAccount: selectedAccount1,
          selectedAcquisitionDate: selectedAcquisitionDate,
        },
        "check10",
      );
      if (fromDate1 && toDate1) {
        ReportsStore.updateTableDataLoader(true);
        ReportsStore.getDataForTransectionReport(
          `${fromDate1?.year}-${fromDate1?.month}-${fromDate1?.date}`,
          `${toDate1?.year}-${toDate1?.month}-${toDate1?.date}`,
          false,
          {
            IsAcquisition: getAcquisitionValue({
              data: selectedAcquisitionDate,
            }),
          },
        );
      }
    }
  };
  const onClearFilter = () => {
    const defaultDateType = getDefaultDateType({
      data: UserStore.usersData,
    });
    setSearch("");
    setSelectedSuggetion(null);
    setFilteredColumn("transaction_date");
    ReportsStore.updateTableDataLoader(true);
    ReportsStore.updateTransectionFilter(
      {
        timePeriod: "current_month",
        transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
        upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
        selectedMember:
          getDecodedToken()?.user_type === "manager" ||
          (getDecodedToken()?.user_type === "employee" &&
            UserStore?.selectedClientId !== "0") ||
          (getDecodedToken()?.user_type === "customer" &&
            getDecodedToken()?.primary === "false") ||
          UserStore?.selectedClientId !== "0"
            ? UserStore.transectionReportFilter.selectedMember
            : "All",
        selectedAssetClass: "All",
        selectedAccount: "All",
        selectedAcquisitionDate: defaultDateType,
      },
      "check11",
    );

    let as_of_date = getAsOfDate(UserStore.asOfDate);
    if (!getAsOfDate(UserStore.asOfDate)) as_of_date = getCookie("asOfDate");
    const dateObjofAsOfDate = new Date(as_of_date);
    let formattedFromdate;
    let newFromdate;

    newFromdate = new Date(
      dateObjofAsOfDate.getFullYear(),
      dateObjofAsOfDate.getMonth(),
      1,
    );
    formattedFromdate =
      newFromdate?.getFullYear() +
      "-" +
      padNumber(newFromdate?.getMonth() + 1) +
      "-" +
      padNumber(newFromdate?.getDate());
    const fromDate = convertDateToObj(formattedFromdate);
    const toDate = convertDateToObj(as_of_date);

    if (fromDate && toDate) {
      ReportsStore.updateTableDataLoader(true);
      ReportsStore.getDataForTransectionReport(
        `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
        `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
        false,
        {
          IsAcquisition: getAcquisitionValue({ data: defaultDateType }),
        },
      );
    }
  };

  const getTransactionsData = () => {
    return vertualRows;
  };

  const getUpcomingTransactionsData = () => {
    return upcomingtransactionsData?.filter((eachTransaction) => {
      return selectedSuggetion
        ? eachTransaction?.security_name === selectedSuggetion?.title
        : true;
    });
  };

  const checkAccountsDropdownDisabled = () => {
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        !UserStore.userData?.isprimary &&
        UserStore?.selectedClientId !== "0") ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false") ||
      ((getDecodedToken()?.user_type === "customer" ||
        getDecodedToken()?.user_type === "employee") &&
        UserStore.currentFamilyMembers?.length === 1)
    ) {
      return false;
    } else if (selectedMember.length === 0) {
      return true;
    } else {
      return (
        selectedMember === "All" ||
        UserStore.currentFamilyMembers
          ?.map((familyMember) =>
            selectedMember?.find(
              (member) => member?.user_id === familyMember?.user_id,
            ),
          )
          ?.every(Boolean)
      );
    }
  };

  useEffect(() => {
    const vertualRows = ReportsStore.transectionTableData
      ? ReportsStore.transectionTableData
      : [];
    const tempSuggetionArr = [];
    (timePeriod === "last_10"
      ? vertualRows?.slice(0, 10)
      : vertualRows
    )?.forEach((transaction) => {
      if (
        transaction.security_name
          .toLocaleLowerCase()
          .includes(search.toLocaleLowerCase())
      ) {
        tempSuggetionArr.push({
          title: transaction.security_name,
          from: "recent_transaction",
        });
      }
    });

    (timePeriod === "last_10"
      ? upcomingtransactionsData?.slice(0, 10)
      : upcomingtransactionsData
    )?.forEach((transaction) => {
      if (
        transaction?.security_name
          ?.toLocaleLowerCase()
          ?.includes(search?.toLocaleLowerCase())
      ) {
        tempSuggetionArr.push({
          title: transaction.security_name,
          from: "upcoming_transactions",
        });
      }
    });

    if (search && tempSuggetionArr.length) {
      setSearchSuggetions(
        [...new Set(tempSuggetionArr.map((o) => JSON.stringify(o)))].map((s) =>
          JSON.parse(s),
        ),
      );
    } else {
      setSearchSuggetions([]);
      setSelectedSuggetion(null);
    }
    // eslint-disable-next-line
  }, [search]);

  const SearchMenuContent = () => {
    return (
      <>
        {searchSuggetions?.length ? (
          <div
            ref={ref}
            className="suggetion_box_for_search"
            id="transaction_suggetion_box_for_search"
          >
            {searchSuggetions.map((suggetion, index) => (
              <div
                className="suggetion"
                tabIndex="0"
                key={index}
                onKeyDown={handleKeydownForSuggetion}
                onClick={() => {
                  setSelectedSuggetion(suggetion);
                  setSearchSuggetionOpen(false);
                  setSearch(suggetion.title);
                  // ReportsStore.updateTransectionReportTab("");
                  // setTimeout(() => {
                  ReportsStore.updateTransectionReportTab(suggetion.from);
                  //}, 1);
                }}
              >
                {suggetion.title}
              </div>
            ))}
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    if (searchSuggetions.length) setSearchSuggetionOpen(true);
    else setSearchSuggetionOpen(false);
    if (!e.target.value) {
      setSelectedSuggetion(null);
    }
  };

  const handleTimePeriodReset = () => {
    setFromDate(initialFromDate);
    setToDate(initialToDate);
  };

  const isInfinity = UserStore.infinityData?.actual_value;

  const navigateToInfinity = () => {
    ReportsStore.updateTableDataLoader(true);
    navigate("/reports/infinity-transactions-report");
  };

  useEffect(() => {
    let rowData = search
      ? searchedData
      : ReportsStore.rememberedTransectionTableData;
    if (rowData) {
      if (filteredColumn === "security_name" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "security_name" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "type" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "type" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "quantity" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]).toFixed(2) -
              Number(b?.[filteredColumn]).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "quantity" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]).toFixed(2) -
                Number(b?.[filteredColumn]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "rate" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]).toFixed(2) -
              Number(b?.[filteredColumn]).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "rate" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]).toFixed(2) -
                Number(b?.[filteredColumn]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "amount" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
              Number(b?.[filteredColumn]?.actual_value).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "amount" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
                Number(b?.[filteredColumn]?.actual_value).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "amount" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
              Number(b?.[filteredColumn]?.actual_value).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "amount" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
                Number(b?.[filteredColumn]?.actual_value).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "transaction_date" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumn]?.split("-")?.join();
            let bb = b?.[filteredColumn]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (filteredColumn === "transaction_date" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.split("-")?.join();
              let bb = b?.[filteredColumn]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
      if (filteredColumn === "expiry_date" && isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumn]?.split("-")?.join();
            let bb = b?.[filteredColumn]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (filteredColumn === "expiry_date" && !isAscendingForHeader) {
        ReportsStore.updateTransactionReportData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.split("-")?.join();
              let bb = b?.[filteredColumn]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
    }
    // eslint-disable-next-line
  }, [filteredColumn, isAscendingForHeader]);

  useEffect(() => {
    let rowData = ReportsStore.rememberedupcomingtransectionTableData;
    if (rowData) {
      if (
        filteredColumnForUpcoming === "security_name" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumnForUpcoming].localeCompare(
              a?.[filteredColumnForUpcoming],
            ),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "security_name" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumnForUpcoming].localeCompare(
                a?.[filteredColumnForUpcoming],
              ),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "type" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumnForUpcoming].localeCompare(
              a?.[filteredColumnForUpcoming],
            ),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "type" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumnForUpcoming].localeCompare(
                a?.[filteredColumnForUpcoming],
              ),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "frequency" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "frequency" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
                Number(b?.[filteredColumnForUpcoming]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "rate" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "rate" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
                Number(b?.[filteredColumnForUpcoming]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "drawcount" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "drawcount" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
                Number(b?.[filteredColumnForUpcoming]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "amount" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]?.actual_value).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]?.actual_value).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "amount" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]?.actual_value).toFixed(
                  2,
                ) -
                Number(b?.[filteredColumnForUpcoming]?.actual_value).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "lastpaymentdate" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
            let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (
        filteredColumnForUpcoming === "lastpaymentdate" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
              let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "expiry_date" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
            let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (
        filteredColumnForUpcoming === "expiry_date" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionTableData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
              let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
    }
  }, [filteredColumnForUpcoming, isAscendingForHeaderForUpcoming]);

  useEffect(() => {
    if (ReportsStore.selectedTabForTransaction === "recent_transaction") {
      trackEventWithScreen({
        eventName: REPORTS_PAGE,
        screenName: RECENT_TRANSACTIONS,
      });

      logEvents(REPORTS_PAGE, {
        screenName: RECENT_TRANSACTIONS,
      });
    } else {
      trackEventWithScreen({
        eventName: REPORTS_PAGE,
        screenName: UPCOMING_TRANSACTIONS,
      });

      logEvents(REPORTS_PAGE, {
        screenName: UPCOMING_TRANSACTIONS,
      });
    }
  }, [
    selectedTabs,
    //ReportsStore.selectedTabForTransaction
  ]);

  // Apply focus on selected list item in report type dropdown content when focus index is changed
  // useEffect(() => {
  //   itemRefs.current[focusedIndex]?.focus();
  // }, [focusedIndex]);

  // useEffect(() => {
  //   if (acquisitionDateMenuOpen) {
  //     const selectedIndex = acquisitionOptions.indexOf(selectedAcquisitionDate);
  //     setFocusedIndex(selectedIndex >= 0 ? selectedIndex : 0);
  //   }
  // }, [acquisitionDateMenuOpen]);

  const handleSortForTransaction = (filterType) => {
    setFilteredColumn(filterType);
    setIsAscendingForHeader(!isAscendingForHeader);
  };

  const handleSortForTransactionForUpcoming = (filterType) => {
    setFilteredColumnForUpcoming(filterType);
    setIsAscendingForHeaderForUpcoming(!isAscendingForHeaderForUpcoming);
  };

  const getTransactionsDataForPDF = () => {
    return ReportsStore.rememberedTransectionTableData;
  };

  return (
    <Observer>
      {() => (
        <div>
          <PageTitle title={"Transaction Report"} />
          {AuthStore.isLoadingFullScreen ||
          loading ||
          (!UserStore.isHydrated &&
            !UserStore.forReportsInceptionDate &&
            !getAsOfDate(UserStore.asOfDate)) ? (
            <LoadingScreen />
          ) : (
            <>
              <Header type="reports" />
              <div className="reports_outer_main">
                <div className="transection_header_container">
                  <PageHeading headingClass="head" headingText="Transactions" />
                  <div className="search_extractdata_wrapper">
                    {isInfinity && (
                      <div
                        className="view_infinity_holdings_btn"
                        onClick={navigateToInfinity}
                      >
                        <button className="darkBlueTextColor darkBlueBorderColor">
                          View Infinity Transactions
                        </button>
                      </div>
                    )}
                    <PopupMenu
                      MenuContent={SearchMenuContent}
                      open={searchSuggetionOpen}
                      setOpen={setSearchSuggetionOpen}
                      position={{ top: "50px", left: "0px" }}
                      showArrow={false}
                    >
                      <div className="search_input_container">
                        <img
                          className="search_icon"
                          src={search_svg}
                          alt="search"
                        />
                        <input
                          type="text"
                          id="search-box"
                          autoComplete="off"
                          className="search_input"
                          value={search}
                          placeholder="Search"
                          onKeyDown={handleKeyPress}
                          onChange={handleSearchChange}
                        />
                        <button
                          className="close_icon clickable"
                          onClick={() => setSearch("")}
                          aria-label="Clear Search"
                        >
                          <img src={closeInput} />
                        </button>
                      </div>
                    </PopupMenu>{" "}
                    {/* <div
                      ref={exportRef}
                      // onClick={() =>
                      //   !niftyMenu ? setNiftyMenu(true) : setNiftyMenu(false)
                      // }
                    >
                      <PopupMenu
                        position={{ top: "59px", right: "2px" }}
                        setOpen={setNiftyMenu}
                        open={niftyMenu}
                        MenuContent={ExtractDataContent}
                      >
                        <div className="export_data_btn">
                          <p className="export_data_text">Export Data</p>
                          <div className="export_text_wrapper">
                            <p className="export_type">Excel</p>
                            <DownArrow />
                          </div>
                        </div>
                      </PopupMenu>
                    </div> */}
                    <div className="reports-export-wrapper">
                      <ExportReportList
                        exportExcel={() => {
                          const fileName = `${getExcelPdfName(
                            "Transactions Report -",
                            UserStore?.transectionReportFilter?.selectedMember,
                            UserStore?.transectionReportFilter?.selectedAccount,
                            UserStore.getData,
                            UserStore.userData.full_name,
                          )} - ${getCurrentDate()} ${getCurrentTime()} - ${getDateType(
                            {
                              data:
                                UserStore.transectionReportFilter
                                  .selectedAcquisitionDate ||
                                getDefaultDateType({
                                  data: UserStore.usersData,
                                }),
                            },
                          )}`;
                          exportExcel({
                            dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
                            sheetname: "Transactions",
                            isFamilyOnly: true,
                            // customNameWithTime: getExcelPdfName(
                            //   "",
                            //   UserStore?.transectionReportFilter?.selectedMember,
                            //   UserStore?.transectionReportFilter?.selectedAccount,
                            //   UserStore.getData,
                            //   UserStore.userData.full_name
                            // ),
                            columns:
                              ReportsStore.selectedTabForTransaction ===
                              "recent_transaction"
                                ? columTransactionForPDF
                                : corporateActionsColumns,
                            data:
                              (ReportsStore.selectedTabForTransaction ===
                              "recent_transaction"
                                ? getTransactionsDataForPDF()
                                : getUpcomingTransactionsData()) || [],
                            reportDetails: {
                              relatioshipManager:
                                UserStore?.exportDetails?.find(
                                  (item) => item.role === "RM",
                                )?.name,
                              serviceManager: UserStore?.exportDetails?.find(
                                (item) => item.role === "CXO",
                              )?.name,
                              date: getPrintDate(
                                getAsOfDate(UserStore.asOfDate),
                              ),
                              clientName:
                                //UserStore.getData === "fam"
                                //?
                                UserStore.userData?.family_name,
                              //: UserStore.userData?.full_name,
                            },
                            excelName: fileName,
                          });
                        }}
                        exportPdf={async () => {
                          const fileName = `${getExcelPdfName(
                            "Transactions Report -",
                            UserStore?.transectionReportFilter?.selectedMember,
                            UserStore?.transectionReportFilter?.selectedAccount,
                            UserStore.getData,
                            UserStore.userData.full_name,
                          )} - ${getCurrentDate()} ${getCurrentTime()} - ${getDateType(
                            {
                              data:
                                UserStore.transectionReportFilter
                                  .selectedAcquisitionDate ||
                                getDefaultDateType({
                                  data: UserStore.usersData,
                                }),
                            },
                          )}`;
                          // printDocument(recentTransactionId, {
                          //   width: 850,
                          //   height: 850,
                          //   customFileName: fileName,
                          // });
                          if (isDownloading) return; // guard against double-click while already running
                          setIsDownloading(true);
                          try {
                            await downloadPDFFile({
                              customFileName: fileName,
                              headerName: "Transactions",
                              fileId: recentTransactionId,
                              isFamilyOnly: true,
                              dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
                              familyOrClientName:
                                UserStore.userData?.family_name,
                              columns:
                                ReportsStore.selectedTabForTransaction ===
                                "recent_transaction"
                                  ? columTransactionForPDF
                                  : corporateActionsColumns,
                              data:
                                (ReportsStore.selectedTabForTransaction ===
                                "recent_transaction"
                                  ? getTransactionsDataForPDF()
                                  : getUpcomingTransactionsData()) || [],
                            });
                          } finally {
                            setIsDownloading(false);
                            //setNiftyMenu(false);
                          }
                        }}
                        buttonProps={{
                          buttonType: "reportExport",
                        }}
                        popupClassName={{
                          open: "clicked-hover",
                          close: "",
                          wrapperClass: "popup_menu_container",
                          containerClass: "downloadPdf",
                        }}
                        restrictHover={true}
                        itemRefs={exportItemRefs}
                        menuItems={exportDataMenu}
                        accessibilityValues={{
                          buttonId: "export-dropdown",
                          ariaHaspopup: "menu",
                          ariaControls: "extract-menu",
                          ariaLabel: "Extract Data",
                        }}
                      >
                        <>
                          {isDownloading && (
                            <div className="popup_downloader">
                              <img src={loaderGIF} alt="img" />
                            </div>
                          )}
                        </>
                      </ExportReportList>
                    </div>
                  </div>
                </div>
                <div className="reports_yellow_container">
                  <div className="transecitons_yellow_wrapper">
                    <div className="transections_first_container">
                      <div
                        className={`time_period_container ${
                          ReportsStore.selectedTabForTransaction ===
                          "upcoming_transactions"
                            ? "disabled_time_period"
                            : ""
                        }`}
                      >
                        <RadioGroup
                          heading="Time Period"
                          name="time_period"
                          radioBtnArray={transectionsTimePeriodRadioBtnsData}
                          handleChange={handleTimePeriodChange}
                          value={timePeriod}
                          radioBtnsPerRow={4}
                          groupId={"transactions-time-period"}
                          groupName={"transactions-radio-group1"}
                          isDisabled={
                            ReportsStore.selectedTabForTransaction ===
                            "upcoming_transactions"
                          }
                        />
                        <DatePicker2
                          timePeriod={timePeriod}
                          fromDate={fromDate}
                          toDate={toDate}
                          setFromDate={setFromDate}
                          setToDate={setToDate}
                          initialFromDate={initialFromDate}
                          initialToDate={initialToDate}
                          resetedFromDate={resetedFromDate}
                          resetedToDate={resetedToDate}
                          handleReset={handleTimePeriodReset}
                          isActive={
                            ReportsStore.selectedTabForTransaction !==
                            "upcoming_transactions"
                          }
                          // isActive={timePeriod === "custom"}
                          open={datePickerModalOpen}
                          setOpen={() => {
                            handleTimePeriodChange("custom");

                            setDatePickerModalOpen(true);
                          }}
                          onClose={() => setDatePickerModalOpen(false)}
                        />
                      </div>
                    </div>
                    <div className="transections_second_container">
                      <div
                        className="transection_type_container"
                        role="group"
                        aria-labelledby="transaction-type-heading"
                      >
                        <h2
                          id="transaction-type-heading"
                          className="transection_type_heading"
                        >
                          Transaction Type
                        </h2>
                        <div className="transection_type_checkboxes">
                          {ReportsStore.selectedTabForTransaction ===
                          "recent_transaction" ? (
                            <>
                              <div
                                className={
                                  selectedTransecitonTypes?.includes(
                                    "BOUGHT",
                                  ) && selectedTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() => handleTranTypeChange("BOUGHT")}
                              >
                                <input
                                  id="bought"
                                  style={{
                                    cursor:
                                      selectedTransecitonTypes?.includes(
                                        "BOUGHT",
                                      ) &&
                                      selectedTransecitonTypes?.length === 1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedTransecitonTypes?.includes(
                                    "BOUGHT",
                                  )}
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="bought" className="unitFont">
                                  Bought
                                </label>
                              </div>
                              <div
                                className={
                                  selectedTransecitonTypes?.includes("SOLD") &&
                                  selectedTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() => handleTranTypeChange("SOLD")}
                              >
                                <input
                                  id="sold"
                                  style={{
                                    cursor:
                                      selectedTransecitonTypes?.includes(
                                        "SOLD",
                                      ) &&
                                      selectedTransecitonTypes?.length === 1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedTransecitonTypes?.includes(
                                    "SOLD",
                                  )}
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="sold" className="unitFont">
                                  Sold
                                </label>
                              </div>
                              <div
                                className={
                                  selectedTransecitonTypes?.includes("BONUS") &&
                                  selectedTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() => handleTranTypeChange("BONUS")}
                              >
                                <input
                                  id="bonus"
                                  style={{
                                    cursor:
                                      selectedTransecitonTypes?.includes(
                                        "BONUS",
                                      ) &&
                                      selectedTransecitonTypes?.length === 1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedTransecitonTypes?.includes(
                                    "BONUS",
                                  )}
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="bonus" className="unitFont">
                                  Bonus
                                </label>
                              </div>
                              <div
                                className={
                                  selectedTransecitonTypes?.includes("SPLIT") &&
                                  selectedTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() => handleTranTypeChange("SPLIT")}
                              >
                                <input
                                  id="split"
                                  style={{
                                    cursor:
                                      selectedTransecitonTypes?.includes(
                                        "SPLIT",
                                      ) &&
                                      selectedTransecitonTypes?.length === 1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedTransecitonTypes?.includes(
                                    "SPLIT",
                                  )}
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="split" className="unitFont">
                                  Split
                                </label>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className={
                                  selectedUpcomingTransecitonTypes?.includes(
                                    "SIP",
                                  ) &&
                                  selectedUpcomingTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() =>
                                  handleTranTypeChange("SIP", "upcoming")
                                }
                              >
                                <input
                                  id="sip"
                                  style={{
                                    cursor:
                                      selectedUpcomingTransecitonTypes?.includes(
                                        "SIP",
                                      ) &&
                                      selectedUpcomingTransecitonTypes?.length ===
                                        1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedUpcomingTransecitonTypes?.includes(
                                    "SIP",
                                  )}
                                  onChange={() =>
                                    handleTranTypeChange("SIP", "upcoming")
                                  }
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="sip" className="unitFont">
                                  SIP
                                </label>
                              </div>
                              <div
                                className={
                                  selectedUpcomingTransecitonTypes?.includes(
                                    "STP",
                                  ) &&
                                  selectedUpcomingTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() =>
                                  handleTranTypeChange("STP", "upcoming")
                                }
                              >
                                <input
                                  id="stp"
                                  style={{
                                    cursor:
                                      selectedUpcomingTransecitonTypes?.includes(
                                        "STP",
                                      ) &&
                                      selectedUpcomingTransecitonTypes?.length ===
                                        1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedUpcomingTransecitonTypes?.includes(
                                    "STP",
                                  )}
                                  onChange={() =>
                                    handleTranTypeChange("STP", "upcoming")
                                  }
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="stp" className="unitFont">
                                  STP
                                </label>
                              </div>
                              <div
                                className={
                                  selectedUpcomingTransecitonTypes?.includes(
                                    "SWP",
                                  ) &&
                                  selectedUpcomingTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() =>
                                  handleTranTypeChange("SWP", "upcoming")
                                }
                              >
                                <input
                                  id="swp"
                                  style={{
                                    cursor:
                                      selectedUpcomingTransecitonTypes?.includes(
                                        "SWP",
                                      ) &&
                                      selectedUpcomingTransecitonTypes?.length ===
                                        1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedUpcomingTransecitonTypes?.includes(
                                    "SWP",
                                  )}
                                  onChange={() =>
                                    handleTranTypeChange("SWP", "upcoming")
                                  }
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="swp" className="unitFont">
                                  SWP
                                </label>
                              </div>
                              <div
                                className={
                                  selectedUpcomingTransecitonTypes?.includes(
                                    "DRAWDOWN",
                                  ) &&
                                  selectedUpcomingTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() =>
                                  handleTranTypeChange("DRAWDOWN", "upcoming")
                                }
                              >
                                <input
                                  id="drawdown"
                                  style={{
                                    cursor:
                                      selectedUpcomingTransecitonTypes?.includes(
                                        "DRAWDOWN",
                                      ) &&
                                      selectedUpcomingTransecitonTypes?.length ===
                                        1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedUpcomingTransecitonTypes?.includes(
                                    "DRAWDOWN",
                                  )}
                                  onChange={() =>
                                    handleTranTypeChange("DRAWDOWN", "upcoming")
                                  }
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="drawdown" className="unitFont">
                                  Drawdown
                                </label>
                              </div>
                              <div
                                className={
                                  selectedUpcomingTransecitonTypes?.includes(
                                    "MATURITY",
                                  ) &&
                                  selectedUpcomingTransecitonTypes?.length === 1
                                    ? "each_checkbox_wrapper"
                                    : "each_checkbox_wrapper cursor"
                                }
                                onClick={() =>
                                  handleTranTypeChange("MATURITY", "upcoming")
                                }
                              >
                                <input
                                  id="maturity"
                                  style={{
                                    cursor:
                                      selectedUpcomingTransecitonTypes?.includes(
                                        "MATURITY",
                                      ) &&
                                      selectedUpcomingTransecitonTypes?.length ===
                                        1
                                        ? "text"
                                        : "pointer",
                                  }}
                                  checked={selectedUpcomingTransecitonTypes?.includes(
                                    "MATURITY",
                                  )}
                                  onChange={() =>
                                    handleTranTypeChange("MATURITY", "upcoming")
                                  }
                                  type="checkbox"
                                  className="checkbox"
                                />
                                <label htmlFor="maturity" className="unitFont">
                                  Maturity
                                </label>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="dropdown_container">
                        <AssetClassesCheckBox
                          heading={getHeadingForAssetClass(selectedAssetClass)}
                          position={{
                            top: "56px",
                            left: "0px",
                            zIndex: "20",
                            padding: "3px",
                            overflowY: "hidden",
                            border: "1px solid #e3e3e3",
                          }}
                          showArrow={true}
                          headingValue={selectedAssetClass}
                          allData={ReportsStore.allAssetClassesData}
                          setHeadingValue={(changedAssetClass) => {
                            if (changedAssetClass === "All") {
                              if (
                                selectedAssetClass === "All" ||
                                ReportsStore.allAssetClassesData
                                  ?.map((assetClass) =>
                                    selectedAssetClass?.includes(assetClass.id),
                                  )
                                  ?.every(Boolean)
                              ) {
                                setSelectedAssetClass([]);
                              } else {
                                setSelectedAssetClass(
                                  ReportsStore.allAssetClassesData?.map(
                                    (assetClass) => {
                                      return assetClass?.id;
                                    },
                                  ),
                                );
                              }
                            } else {
                              if (selectedAssetClass === "All") {
                                setSelectedAssetClass(
                                  ReportsStore.allAssetClassesData
                                    ?.map((assetClass) => {
                                      return assetClass?.id;
                                    })
                                    .filter(
                                      (assetClassId) =>
                                        assetClassId !== changedAssetClass,
                                    ),
                                );
                              } else {
                                if (
                                  selectedAssetClass?.includes(
                                    changedAssetClass,
                                  )
                                ) {
                                  setSelectedAssetClass((prevState) => {
                                    return prevState.filter(
                                      (eachAssetClass) =>
                                        eachAssetClass !== changedAssetClass,
                                    );
                                  });
                                } else {
                                  setSelectedAssetClass([
                                    ...selectedAssetClass,
                                    changedAssetClass,
                                  ]);
                                }
                              }
                            }
                          }}
                          //showPopup={true}
                          showArrow={false}
                          // disabledPopup={
                          //   ReportsStore.usersAccounts.length === 1
                          // }
                          //isDisabled={false}
                          popupClassName={{
                            wrapperClass:
                              "popup_menu_container dropdown-wrapper",
                            dropDownContainerClass: "all_accounts_dropdown",
                            popupMenuClass: "",
                          }}
                          restrictHover={true}
                          OPTIONS={[
                            {
                              id: "All",
                              name: "All Asset Classes",
                            },
                          ].concat(ReportsStore.allAssetClassesData)}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "listbox",
                            ariaControls: "asset-listbox",
                            ariaLabel: "Asset Class Filters",
                          }}
                        />
                        <GoldenDropDown
                          isDisabled={
                            ReportsStore.selectedTabForTransaction !==
                            "recent_transaction"
                          }
                          heading={getHeadingForMembers(selectedMember)}
                          selectedMember={selectedMember}
                          showPopup={
                            getDecodedToken()?.user_type === "manager" ||
                            (getDecodedToken()?.user_type === "employee" &&
                              UserStore?.selectedClientId !== "0") ||
                            (getDecodedToken()?.user_type === "customer" &&
                              getDecodedToken()?.primary === "false") ||
                            UserStore?.selectedClientId !== "0" ||
                            ((getDecodedToken()?.user_type === "customer" ||
                              getDecodedToken()?.user_type === "employee") &&
                              UserStore.currentFamilyMembers?.length === 1)
                              ? false
                              : true
                          }
                          popupMenuClass="reports_select_family_member_popup_menu"
                          ReportMenuContent={AllMembersMenuContent}
                          reportsMenuOpen={allMembersMenuOpen}
                          setReportsMenuOpen={setAllMembersMenuOpen}
                          position={{
                            top: "57px",
                            left: "0px",
                            minWidth: "380px",
                          }}
                          showArrow={false}
                          dropDownContainerClass="all_members_dropdown"
                        />
                        <AccountsDropDown
                          heading={
                            ReportsStore.selectedTabForTransaction ===
                            "recent_transaction"
                              ? selectedAccount1 !== "All"
                                ? selectedAccount1.account_Name
                                : selectedMember.length === 0
                                  ? "None selected"
                                  : "All Accounts"
                              : "All Accounts"
                          }
                          headingValue={selectedAccount1}
                          setHeadingValue={(data) => {
                            setSelectedAccount1(data);
                          }}
                          position={{
                            top: "56px",
                            left: "0px",
                            zIndex: "20",
                            padding: "3px",
                            overflowY: "hidden",
                            border: "1px solid #e3e3e3",
                          }}
                          showPopup={true}
                          showArrow={false}
                          // disabledPopup={
                          //   ReportsStore.usersAccounts.length === 1
                          // }
                          isDisabled={
                            ReportsStore.selectedTabForTransaction ===
                            "recent_transaction"
                              ? checkAccountsDropdownDisabled()
                              : true
                          }
                          popupClassName={{
                            wrapperClass: "popup_menu_container",
                            dropDownContainerClass: "all_accounts_dropdown ",
                            popupMenuClass: "",
                          }}
                          restrictHover={true}
                          OPTIONS={[
                            {
                              account_Code: "All",
                              account_Name: "All Accounts",
                            },
                          ].concat(getAccountsList())}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "radiogroup",
                            ariaControls: "accounts-options",
                            ariaLabel: "Accounts Selection",
                          }}
                          dataKey="account_Code"
                          dataValueKey="account_Name"
                        />
                      </div>

                      <div className="date-type-dropdown-wrapper">
                        {" "}
                        <AcquisitionDateTypeDropdown
                          heading={selectedAcquisitionDate}
                          headingValue={selectedAcquisitionDate}
                          setHeadingValue={(data) =>
                            setSelectedAcquisitionDate(data)
                          }
                          position={{
                            top: "56px",
                            left: "0px",
                            minWidth: "180px",
                            width: "fit-content",
                          }}
                          showArrow={false}
                          isDisabled={
                            ReportsStore.selectedTabForTransaction !==
                            "recent_transaction"
                          }
                          // disabledPopup={selectedStocks?.nodata}
                          popupClassName={{
                            wrapperClass: "popup_menu_container",
                            dropDownContainerClass: "all_accounts_dropdown",
                            popupMenuClass: "",
                          }}
                          restrictHover={true}
                          OPTIONS={acquisitionOptions}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "radiogroup",
                            ariaControls: "date-type-options",
                            ariaLabel: "Date Type",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <ApplyFilter
                    customCss="reusable-button"
                    onApplyFilter={() => onApplyFilter()}
                    onClearFilter={onClearFilter}
                  />
                </div>
                {ReportsStore.tableDataLoader ? (
                  <div className="report_table_loader">
                    <div className="report_loader_wrapper">
                      <img
                        className="loading_gif"
                        src={loaderGIF}
                        alt="loading..."
                      />
                    </div>
                  </div>
                ) : (
                  <div className="transaction_container extra-padding-30">
                    <Tabs
                      onSelect={(value) => {
                        ReportsStore.updateTransectionReportTab(value);
                      }}
                      renderCondition={true}
                      selectedTab={ReportsStore.selectedTabForTransaction}
                      tabs={[
                        {
                          label: "Recent Transaction",
                          value: "recent_transaction",
                        },
                        {
                          label: "Upcoming Transactions",
                          value: "upcoming_transactions",
                        },
                      ]}
                    />
                    <div className="transaction_table_container">
                      {ReportsStore.selectedTabForTransaction ===
                        "recent_transaction" && (
                        <>
                          {ReportsStore.transectionTableData?.length &&
                          !ReportsStore.tableDataLoader ? (
                            <Table
                              data={getTransactionsData()}
                              columns={columTransaction}
                              tableClass="custom_table2 reports-table grey-border-table"
                              handleSort={handleSortForTransaction}
                              sortKey={filteredColumn}
                              isAscending={isAscendingForHeader}
                            />
                          ) : (
                            <div className="empty_state_for_valuation">
                              <EmptyDerivatives
                                image={emptyIcon}
                                message="You do not have any records to display"
                              />
                            </div>
                          )}
                        </>
                      )}
                      {ReportsStore.selectedTabForTransaction ===
                        "upcoming_transactions" && (
                        <>
                          {ReportsStore.upcomingtransectionTableData?.length &&
                          !ReportsStore.tableDataLoader &&
                          getUpcomingTransactionsData()?.length ? (
                            <Table
                              data={getUpcomingTransactionsData()}
                              columns={corporateActionsColumns}
                              tableClass="custom_table3 upcoming reports-table3 grey-border-table"
                              handleSort={handleSortForTransactionForUpcoming}
                              sortKey={filteredColumnForUpcoming}
                              isAscending={isAscendingForHeaderForUpcoming}
                            />
                          ) : (
                            <div className="empty_state_for_valuation">
                              <EmptyDerivatives
                                image={emptyIcon}
                                message="You do not have any records to display"
                              />
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {/* <PdfTable
                isFamilyOnly={true}
                headerName={"Transactions"}
                columns={
                  ReportsStore.selectedTabForTransaction ===
                  "recent_transaction"
                    ? columTransactionForPDF
                    : corporateActionsColumns
                }
                data={
                  (ReportsStore.selectedTabForTransaction ===
                  "recent_transaction"
                    ? getTransactionsDataForPDF()
                    : getUpcomingTransactionsData()) || []
                }
                familyOrClientName={
                  UserStore.userData?.family_name

                  //   getExcelPdfName(
                  //   "",
                  //   UserStore?.transectionReportFilter?.selectedMember,
                  //   UserStore?.transectionReportFilter?.selectedAccount,
                  //   UserStore.getData,
                  //   UserStore.userData.full_name
                  // )
                }
                id={recentTransactionId}
                dateRange={`${getDateString(fromDate)} To ${getDateString(
                  toDate,
                )}`}
              /> */}
            </>
          )}
        </div>
      )}
    </Observer>
  );
});

export default TransactionsReport;
